<template>
  <div class="class-wrong-details">
    <template v-if="questionContentData && questionDataList">
    <div class="top-charts-panel">
      <div class="chart-container pie-container">
        <div class="text">作答人数：</div>
        <!-- <div class="panel-pie-chart">
          <div class="pie-chart"
            :style="{
            '--progress': `${questionDataList.totalNum !==0 ? (questionDataList.answerNum / questionDataList.totalNum *100).toFixed(2) : 0}%`
            }"
          ></div>
        </div> -->
        <div class="panel-pie-data">{{questionDataList.answerNum}}人</div>
      </div>
      <div class="chart-container bar-container">
        <div class="text">错误率：</div>
        <div class="panel-bar-chart">
          <div class="bar-chart" :style="{width: `${questionDataList.errorRate}%`}"></div>
        </div>
        <div class="panel-bar-data">{{questionDataList.errorRate}}%</div>
      </div>
    </div>
    <div class="scroll-content">
      <div v-if="questionType !== questionTypes[5]" class="question-container" :class="questionAnswerOptions[questionType].className">
        <div class="title-type-tag">{{questionAnswerOptions[questionType].title}}</div>
        <div class="title-stem">{{questionContentData.content}}</div>
        <el-carousel class="carousel-container" v-if="questionContentData.contentImg" :indicator-position="'outside'" :interval="5000" arrow="never">
          <el-carousel-item v-for="(v,i) in questionContentData.setImgArr" :key="i">
            <div class="title-images" v-for="(k) in v" :key="k.fileUrl" @click="openImageBox(questionContentData.httpcontentImage,k.index)">
              <img class="img-title-picture" :src="encodeURI(k.fileUrl)" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="answer-tag">
          <img src="../../assets/images/class-answer-tag.png" class="img-answer-tag" />
          <div class="text">作答分析</div>
        </div>
        <template v-if="(questionType === questionTypes[0] || questionType === questionTypes[1]) && questionDataList.answerDetail.length>0" >
          <div v-for="(item, index) in questionDataList.answerDetail" :key="index" class="answer-status"
            :class="item.type === 'mostWrong' ? 'answer-most-wrong' : item.type === 'right' ? 'answer-right' : '' ">
            <template v-if="item.options">
              <div class="text">{{item.options.tab}}: {{item.options.content}}</div>
              <div v-if="item.options.fileUrl" class="option-image">
                <img :src="item.options.fileUrl" class="img-option-picture" @click="openImageBox(item.options, index)" />
              </div>
            </template>
            <div class="graph">
              <div class="chart-container">
                <div class="chart" :style="{width: `${item.keyRate}%`}"></div>
              </div>
              <div class="data">{{item.keyRate}}%</div>
            </div>
          </div>
        </template>
        <template v-else-if="questionType === questionTypes[2] && questionDataList.answerDetail.length>0
            && questionDataList.errorAnswerDetail && questionDataList.correctAnswerDetail">
          <div class="answer-text">
            <div class="wrong">错误 {{questionDataList.errorAnswerDetail.keyRate}}%</div>
            <div class="right">正确 {{questionDataList.correctAnswerDetail.keyRate}}%</div>
          </div>
          <div class="answer-charts">
            <div class="chart-wrong" :style="{width: `${questionDataList.errorAnswerDetail.keyRate}%`}"></div>
            <div class="chart-right" :style="{width: `${questionDataList.correctAnswerDetail.keyRate}%`}"></div>
          </div>
        </template>
        <template v-else-if="questionType === questionTypes[3] && questionDataList.answerDetail.length>0">
          <div v-for="(item, index) in questionDataList.answerDetail" :key="index" class="answer-status">
            <div class="tag">第{{num2cn(index + 1)}}空</div>
            <div class="answer-text">
              <div class="text">{{item.key}}</div>
              <div class="data">{{item.keyRate}}%</div>
            </div>
            <div v-if="item.options && item.options.fileUrl" class="option-image">
              <img :src="item.options && item.options.fileUrl" class="img-option-picture" @click="openImageBox(item, index)" />
            </div>
            <div class="answer-charts">
              <div v-for="(itm, idx) in item.answerList" :key="idx"
                :style="{width: `${itm.keyRate}%`}" class="chart-normal"
                :class="itm.type === 'mostWrong' ? 'chart-most-wrong' : itm.type === 'right' ? 'chart-right' : '' "
              >{{itm.key === 'correct' ? '正确答案' : itm.key === 'error' ? '其他' : '未作答'}}</div>
            </div>
          </div>
        </template>
        <template v-else-if="questionType === questionTypes[4] && questionDataList.answerDetail.length>0">
          <div v-for="(item, index) in questionDataList.answerDetail" :key="index" class="answer-status">
            <div class="tag">第{{num2cn(index + 1)}}空</div>
            <template v-if="item.options">
              <div class="answer-text">
                <div class="text">{{item.options.tab}}. {{item.options.content}}</div>
                <div class="data">{{item.keyRate}}%</div>
              </div>
              <div v-if="item.options && item.options.fileUrl" class="option-image">
                <img :src="item.options.fileUrl" class="img-option-picture" @click="openImageBox(item.options, index)" />
              </div>
            </template>
            <div class="answer-charts">
              <div v-for="(itm, idx) in item.answerList" :key="idx"
                class="chart-normal" :style="{width: `${itm.keyRate}%`}"
                :class="itm.type === 'mostWrong' ? 'chart-most-wrong' : itm.type === 'right' ? 'chart-right' : '' "
              >{{itm.key=='empty'?'未作答':itm.key}}</div>
            </div>
          </div>
        </template>
      </div>
      
      <div v-else-if="questionType === questionTypes[5]" class="question-container" :class="questionAnswerOptions[questionType].className">
        <div class="title-type-tag">{{questionAnswerOptions[questionType].title}}</div>
        <div class="title-stems">
          <div class="illness">
            <div class="name">病例名称：</div>
            <div class="text">{{questionContentData.title}}</div>
          </div>
          <div class="datum">
            <div class="name">影像资料：</div>
            <div class="panels">
              <div class="panel" v-for="(val, index) in questionContentData.studyUploadList" :key="val.studyUuid" @click="toDatumImages(val.url)">
                <div class="left">
                  <div class="tag">
                    <img src="../../assets/images/yx.png" class="img-datum-tag" draggable="false"/>
                    <div class="text">资源{{index + 1}}</div>
                  </div>
                </div>
                <div class="right">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="apply">
            <div class="name">患者申请单</div>
            <div class="texts">
              <div class="text-t">基本信息:</div>
              <div class="text-c">患者 {{questionContentData.patGender}} {{questionContentData.patAge}}</div>
            </div>
            <div class="texts">
              <div class="text-t">检查部位：</div>
              <div class="text-c">{{questionContentData.checkPoint}}</div>
            </div>
            <div class="texts">
              <div class="text-t">临床诊断：</div>
              <div class="text-c">{{questionContentData.clinic}}</div>
            </div>
            <div class="texts">
              <div class="text-t">检查目的：</div>
              <div class="text-c">{{questionContentData.studyDest}}</div>
            </div>
            <div class="texts">
              <div class="text-t">病例摘要：</div>
              <div class="text-c">{{questionContentData.clinicDiagnosis}}</div>
            </div>
          </div>
          <div class="details">
            <div class="name">报告详情单</div>
            <div class="texts">
              <div class="text-t">检查类型：</div>
              <div class="text-c">{{questionContentData.modality}}</div>
            </div>
            <div class="texts">
              <div class="text-t">检查项目：</div>
              <div class="text-c">{{questionContentData.examItem}}</div>
            </div>
            <div class="texts">
              <div class="text-t">影像学表现：</div>
            </div>
            <div class="texts">
              <div class="text-c green">{{questionContentData.finding}}</div>
            </div>
            <div class="texts">
              <div class="text-t">诊断：</div>
            </div>
            <div class="texts">
              <div class="text-c green">{{questionContentData.conclusion}}</div>
            </div>
          </div>
          <div class="report">
            <div class="name">病理报告</div>
            <div class="texts">
              <div class="text-t">病理诊断：</div>
            </div>
            <div class="texts">
              <div class="text-c green">{{questionContentData.caseDiagnosis}}</div>
            </div>
            <div class="texts">
              <div class="text-t">病理解析：</div>
            </div>
            <div class="texts">
              <div class="text-c green">{{questionContentData.caseAnalysis}}</div>
            </div>
          </div>
        </div>
        <el-carousel class="carousel-container" v-if="questionContentData.caseImgs" :indicator-position="'outside'" :interval="5000" arrow="never">
          <el-carousel-item v-for="(v,i) in questionContentData.setImgArr" :key="i">
            <div class="title-images" v-for="(k) in v" :key="k.fileUrl" @click="openImageBox(questionContentData.httpcontentImage,k.index)">
              <img class="img-title-picture" :src="encodeURI(k.fileUrl)" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="answer-tag">
          <img src="../../assets/images/class-answer-tag.png" class="img-answer-tag" />
          <div class="text">作答分析</div>
        </div>
        <div class="answer-display">影像学表现作答情况</div>
        <template v-if="questionDataList.findDetail">
          <template v-if="questionDataList.findDetail.keyList">
            <div v-for="(item, index) in questionDataList.findDetail.keyList" :key="index" class="answer-status answer-status-display">
              <div class="text">{{item.key}}</div>
              <div class="graph" :class="item.type === 'right' ? 'graph-right' : '' ">
                <div class="chart-container">
                  <div class="chart" :style="{width: `${item.keyRate}%`}"></div>
                </div>
                <div class="data">{{item.keyRate || 0}}%</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="answer-status answer-status-display">
              <div class="text">影像学表现文字比对结果</div>
              <div class="graph graph-right">
                <div class="chart-container">
                  <div class="chart" :style="{width: `${questionDataList.findDetail.totalCorrect}%`}"></div>
                </div>
                <div class="data">{{questionDataList.findDetail.totalCorrect || 0}}%</div>
              </div>
            </div>
          </template>
        </template>
        
        <div class="answer-display">诊断作答情况</div>
        <template v-if="questionDataList.detail">
          <template v-if="questionDataList.detail.keyList">
            <div v-for="(item ,index) in questionDataList.detail.keyList" :key="`${index}-answer-display`" class="answer-status answer-status-diagnose">
              <div class="text">{{item.key}}</div>
              <div class="graph" :class="item.type === 'right' ? 'graph-right' : '' ">
                <div class="chart-container">
                  <div class="chart" :style="{width: `${item.keyRate}%`}"></div>
                </div>
                <div class="data">{{item.keyRate || 0}}%</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="answer-status answer-status-diagnose">
              <div class="text">诊断文字比对结果</div>
              <div class="graph graph-right">
                <div class="chart-container">
                  <div class="chart" :style="{width: `${questionDataList.detail.totalCorrect}%`}"></div>
                </div>
                <div class="data">{{questionDataList.detail.totalCorrect || 0}}%</div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <image-box ref="imageBox"></image-box>
    </template>
    <template v-else>
      <div class="card-empty-status">
        <img class="img-card-empty-status" src="../../assets/images/empty.png" draggable="false" alt="暂无数据～" />
        <div class="text">暂无数据～</div>
      </div>
    </template>
  </div>
</template>

<script>
import imageBox from '../../components/imageBox.vue';
import num2cn from '@/utils/num2cn';
export default {
  name: 'ClassWrongDetails',
  components: { imageBox },
  props: {
    questionType: {
      type: String,
      default: 'single'
    },
    questionDataList: {
      type: Object,
      default: {}
    },
    questionContentData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      questionTypes: ['single', 'multiple', 'judge', 'fill', 'sort', 'illness'],
      questionAnswerOptions: {
        single: {
          name: 'single',
          title: '单选题',
          className: 'single-question'
        },
        multiple: {
          name: 'multiple',
          title: '多选题',
          className: 'multiple-question'
        },
        judge: {
          name: 'judge',
          title: '判断题',
          className: 'judge-question'
        },
        fill: {
          name: 'fill',
          title: '填空题',
          className: 'fill-question'
        },
        sort: {
          name: 'sort',
          title: '排序题',
          className: 'sort-question'
        },
        illness: {
          name: 'illness',
          title: '病例题',
          className: 'illness-question'
        },
      },
    }
  },
  mounted() {
    if(!this.questionContentData || !this.questionDataList) return;
    if(this.questionType === this.questionTypes[5]) {
      this.formattedIllnessData();
    } else {
      this.formattedData();
    }
  },
  methods: {
    num2cn,
    toDatumImages(url) {
      window.open(this.$dimage + url, '_blank');
    },
    formattedData() {
      if(this.questionContentData.contentImg) {
        this.getfileurl(this.questionContentData, this.questionContentData.contentImg, 'httpcontentImage');
        this.$nextTick(() => {
          this.$set(this.questionContentData, 'setImgArr', this.splitArrayIntoGroups(this.questionContentData.httpcontentImage, 4));
        });
      }
      this.questionContentData.options = JSON.parse(this.questionContentData.options);
      this.getfileurl(this.questionContentData, this.questionContentData.options, 'options');
      this.questionDataList.answerDetail = JSON.parse(this.questionDataList.answerDetail);
      if(this.questionType === this.questionTypes[0] || this.questionType === this.questionTypes[1]) {
        const max = this.getMaxAnswerTotalNum(this.questionDataList.answerDetail);
        const answer = this.questionContentData.answer.split(',');
        this.questionDataList.answerDetail.forEach(item => {
          const matchedOptionItem = this.questionContentData.options.find(option => option.tab === item.key);
          if (matchedOptionItem) {
            this.$set(item, 'options', matchedOptionItem);
          }
          if(answer.includes(item.key)) {
            this.$set(item, 'type', 'right');
          } else if(item.totalNum === max) {
            this.$set(item, 'type', 'mostWrong');
          } else {
            this.$set(item, 'type', 'normal');
          }
        });
      } else if(this.questionType === this.questionTypes[2]) {
        this.questionDataList.answerDetail.forEach(item => {
          if(item.key === 'error') {
            this.$set(this.questionDataList, 'errorAnswerDetail', item);
          }else if(item.key === 'correct') {
            this.$set(this.questionDataList, 'correctAnswerDetail', item);
          }
        });
      } else if(this.questionType === this.questionTypes[3]) {
        this.questionDataList.answerDetail.forEach(item => {
          if(this.questionContentData.options) {
            const matchedOptionItem = this.questionContentData.options.find(option => option.tab === item.correctValue);
            if (matchedOptionItem) {
              this.$set(item, 'options', matchedOptionItem);
            }
          }
          const matchedCorrectItem = item.answerList.find(itm => itm.key === 'correct');
          this.$set(item, 'keyRate', matchedCorrectItem ? matchedCorrectItem.keyRate : 0);

          const answerList = item.answerList;
          const maxTotalNum = Math.max(...answerList.map(a => a.totalNum));
          const maxTotalNumItems = answerList.filter(a => a.totalNum === maxTotalNum);
          answerList.forEach(answer => {
            if(answer.key === 'correct') {
              this.$set(answer, 'type', 'right');
            } else if(maxTotalNumItems.includes(answer)) {
              this.$set(answer, 'type', 'mostWrong');
            } else {
              this.$set(answer, 'type', 'normal');
            }
          })
        });
      } else if(this.questionType === this.questionTypes[4]) {
        this.questionDataList.answerDetail.forEach(item => {
          if(this.questionContentData.options) {
            const matchedOptionItem = this.questionContentData.options.find(option => option.tab === item.correctValue);
            if (matchedOptionItem) {
              this.$set(item, 'options', matchedOptionItem);
            }
          }

          const answerList = item.answerList;
          const maxTotalNum = Math.max(...answerList.map(a => a.totalNum));
          const maxTotalNumItems = answerList.filter(a => a.totalNum === maxTotalNum);
          answerList.forEach(answer => {
            if(answer.key === item.correctValue) {
              this.$set(answer, 'type', 'right');
            } else if(maxTotalNumItems.includes(answer)) {
              this.$set(answer, 'type', 'mostWrong');
            } else {
              this.$set(answer, 'type', 'normal');
            }
          })
        });
      }
    },
    formattedIllnessData() {
      if (this.questionContentData.caseImgs ) {
        this.getfileurl(this.questionContentData, this.questionContentData.caseImgs, 'httpcontentImage');
        this.$nextTick(() => {
          this.$set(this.questionContentData, 'setImgArr', this.splitArrayIntoGroups(this.questionContentData.httpcontentImage, 4))
        });
      }
      this.questionDataList.findDetail = JSON.parse(this.questionDataList.findDetail);
      this.questionDataList.detail = JSON.parse(this.questionDataList.detail);
      if(this.questionDataList.findDetail && this.questionDataList.findDetail.keyList) {
        const maxTotalNumFD = Math.max(...this.questionDataList.findDetail.keyList.map(a => a.totalNum));
        const maxTotalNumItemsFD = this.questionDataList.findDetail.keyList.filter(a => a.totalNum === maxTotalNumFD);
        this.questionDataList.findDetail.keyList.forEach(answer => {
          if(maxTotalNumItemsFD.includes(answer)) {
            this.$set(answer, 'type', 'right');
          } else {
            this.$set(answer, 'type', 'normal');
          }
        });
      }
      if(this.questionDataList.detail && this.questionDataList.detail.keyList) {
        const maxTotalNumD = Math.max(...this.questionDataList.detail.keyList.map(a => a.totalNum));
        const maxTotalNumItemsD = this.questionDataList.detail.keyList.filter(a => a.totalNum === maxTotalNumD);
        this.questionDataList.detail.keyList.forEach(answer => {
          if(maxTotalNumItemsD.includes(answer)) {
            this.$set(answer, 'type', 'right');
          } else {
            this.$set(answer, 'type', 'normal');
          }
        });

      }
    },
    getMaxAnswerTotalNum(data) {
      return data.reduce((max, item) => 
        item.totalNum > max ? item.totalNum : max, -Infinity
      );
    },
    splitArrayIntoGroups (arr, groupSize) {
      arr.forEach((v, i) => {
        this.$set(v, 'index', i)
      })
      const result = [];
      for (let i = 0; i < arr.length; i += groupSize) {
        result.push(arr.slice(i, i + groupSize));
      }
      return result;
    },
    getfileurl (item, fileKeys, prop) {
      if (!fileKeys) {
        return
      }
      if (fileKeys.length) {
        if (Array.isArray(fileKeys)) {
          this.$set(item, prop, fileKeys.map(v => { return {...v, key: v.key}}))
        } else {
          this.$set(item, prop, fileKeys.split(',').map(v => { return {key: v}}))
        }
        this.$getUrl({
          fileKeys: Array.isArray(fileKeys) ? fileKeys.map(v => v.key).join() : fileKeys
        }).then(obj => {
          if (obj) {
            item[prop].forEach((e) => {
              if (e) {
                this.$set(e, 'fileUrl', obj[e.key] || '')
              }
            })
          }
        })
      }
    },
    openImageBox (list, index) {
      if (this.$refs.imageBox) {
        let imageList = []
        if (list.fileUrl) {
          imageList.push({ url: `${list.fileUrl}` })
        } else {
          for (let i = 0, length = list.length; i < length; i++) {
            imageList.push({ url: `${list[i].fileUrl}` })
          }
        }
        console.log(imageList, 'imageList')
        this.$refs.imageBox.$emit('open', {
          imageList: imageList,
          index: list.fileUrl ? 0 : index // 问题区图片只有一张 下标传0
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.class-wrong-details {
  height: 100%;
  width: 100%;
  .top-charts-panel {
    width: 100%;
    // height: 40px;
    height: 56px;
    display: flex;
    align-items: flex-start;
    border-bottom: 2px solid #EBEEF5;
    padding: 24px 16px 0 16px;
    .chart-container {
      display: flex;
      align-items: center;
      .text {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        color: #3D3D3D;
      }
    }
    .pie-container {
      .panel-pie-chart {
        width: 22px;
        height: 22px;
        .pie-chart {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: conic-gradient(#366EF4 var(--progress), #c5d2fa 0deg);
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50%;
            height: 50%;
            border-radius: 50%;
            background-color: #ffffff;
          }
        }
      }
      .panel-pie-data {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        color: #003CAB;
        margin-left: 8px;
      }
    }
    .bar-container {
      margin-left: 40px;
      .panel-bar-chart {
        width: 136px;
        height: 8px;
        border-radius: 4.5px;
        background: #fce3e8;
        .bar-chart {
          height: 100%;
          border-radius: 4.5px;
          background: #FC708A;
        }
      }
      .panel-bar-data {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        color: #FC708A;
        margin-left: 8px;
      }
    }
  }
  .scroll-content {
    // height: calc(100% - 40px);
    height: calc(100% - 56px);
    overflow-y: auto;
    padding: 0 16px 24px 16px;
    &::-webkit-scrollbar {
      display: none;
    }
    .question-container {
      .title-type-tag {
        width: 68px;
        height: 28px;
        border-radius: 16px;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        line-height: 27px;
        text-align: center;
        margin: 16px 0;
      }
      .title-stem {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        color: #4B4B4B;
        text-align: left;
        line-height: 26px;
      }
      .title-images {
        flex: 1;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        .img-title-picture {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 0 8px;
          cursor: pointer;
        }
      }
      .answer-tag {
        display: flex;
        align-items: center;
        margin: 16px 0;
        .img-answer-tag {
          width: 16px;
          height: 16px;
          margin-top: 2px;
        }
        .text {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.9);
          margin-left: 6px;
        }
      }
    }
    .option-image {
      height: 86px;
      width: 86px;
      margin: 5px;
      cursor: pointer;
      .img-option-picture {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .single-question, .multiple-question {
      .answer-status {
        .text {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.6);
          text-align: left;
          line-height: 24px;
        }
        .graph {
          display: flex;
          align-items: center;
          margin: 4px 0;
          .chart-container {
            width: calc(100% - 80px);
            .chart {
              height: 16px;
              background: rgba(252, 112, 138, 0.2);
              border-radius: 4px;
            }
          }
          .data {
            width: 80px;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.6);
            text-align: right;
          }
        }
      }
      .answer-most-wrong {
        .graph {
          .chart-container {
            .chart {
              background: #FC708A;
            }
          }
        }
      }
      .answer-right {
        .text {
          font-weight: 600;
          color: #529B2E;
        }
        .graph {
          .chart-container {
            .chart {
              background: #86E23F;
            }
          }
          .data {
            color: #529B2E;
          }
        }
      }
    }
    .single-question {
      .title-type-tag {
        background: #D9ECFF;
        color: #003CAB;
      }
    }
    .multiple-question {
      .title-type-tag {
        background: #E1F3D8;
        color: #1E6101;
      }
    }
    .judge-question {
      .title-type-tag {
        background: #FFD9C2;
        color: #843F00;
      }
      .answer-text {
        font-size: 16px;
        font-weight: normal;
        display: flex;
        justify-content: space-between;
        margin: 4px 0;
        .wrong {
          font-family: PingFang SC;
          color: rgba(0, 0, 0, 0.6);
        }
        .right {
          font-family: PingFang SC;
          color: #529B2E;
        }
      }
      .answer-charts {
        display: -webkit-box;
        width: 100%;
        height: 16px;
        margin-top: 6px;
        box-shadow: 0px 8px 24px 0px rgba(132, 157, 213, 0.2);
        overflow: hidden;
        border-radius: 4px;
        .chart-wrong {
          background: #FC708A;
        }
        .chart-right {
          background: #86E23F;
        }
      }
    }
    .fill-question {
      .title-type-tag {
        background: #EFDBFF;
        color: #531DAB;
      }
      .answer-status{
        .tag {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.9);
          text-align: left;
          margin: 6px 0;
        }
        .answer-text {
          display: flex;
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-weight: normal;
          .text {
            width: calc(100% - 80px);
            font-family: PingFang SC;
            line-height: 24px;
            text-align: left;
          }
          .data {
            width: 80px;
            font-family: PingFang SC;
            text-align: right;
          }
        }
        .answer-charts {
          display: flex;
          width: 100%;
          height: 16px;
          margin-top: 6px;
          box-shadow: 0px 8px 24px 0px rgba(132, 157, 213, 0.2);
          overflow: hidden;
          font-size: 12px;
          color: #FFFFFF;
          border-radius: 4px;
          overflow: hidden;
          .chart-normal {
            margin-right: 1px;
            background: rgba(252, 112, 138, 0.2);
          }
          .chart-right {
            background: #86E23F;
            font-family: PingFang SC;
          }
          .chart-most-wrong {
            background: #FC708A;
            font-family: PingFang SC;
          }
          .chart-normal:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .sort-question {
      .title-type-tag {
        background: #FFF1B8;
        color: #5B4900;
      }
      .answer-status{
        .tag {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.9);
          text-align: left;
          margin: 6px 0;
        }
        .answer-text {
          display: flex;
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-weight: normal;
          .text {
            width: calc(100% - 80px);
            font-family: PingFang SC;
            line-height: 24px;
            text-align: left;
          }
          .data {
            width: 80px;
            font-family: PingFang SC;
            text-align: right;
          }
        }
        .answer-charts {
          display: flex;
          width: 100%;
          height: 16px;
          margin-top: 6px;
          box-shadow: 0px 8px 24px 0px rgba(132, 157, 213, 0.2);
          overflow: hidden;
          font-size: 12px;
          color: #FFFFFF;
          border-radius: 4px;
          overflow: hidden;
          .chart-normal {
            margin-right: 1px;
            background: rgba(252, 112, 138, 0.2);
          }
          .chart-right {
            background: #86E23F;
            font-family: PingFang SC;
          }
          .chart-most-wrong {
            background: #FC708A;
            font-family: PingFang SC;
          }
          .chart-normal:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .illness-question {
      .title-type-tag {
        background: #DCFFFF;
        color: #007979;
      }
      .title-stems {
        .illness {
          display: flex;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: rgba(0, 0, 0, 0.9);
          .name {
            font-family: PingFang SC;
            display: inline-block;
            white-space: nowrap;
          }
          .text {
            font-family: PingFang SC;
            display: inline-block;
            text-align: left;
          }
        }
        .datum {
          .name {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.9);
            text-align: left;
            margin: 4px 0;
          }
          .panels {
            display: flex;
            flex-wrap: wrap;
            .panel {
              width: 184px;
              height: 54px;
              border-radius: 16px;
              box-sizing: border-box;
              border: 2px solid rgba(186, 209, 246, 0.08);
              background: #FAFBFE;
              margin: 4px 0 4px 24px;
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              cursor: pointer;
              .left {
                .tag {
                  display: flex;
                  .img-datum-tag {
                    width: 24px;
                    height: 24px;
                  }
                  .text {
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-weight: 600;
                    color: #3D3D3D;
                  }
                }
                .data {
                  font-family: PingFang SC;
                  font-size: 16px;
                  font-weight: normal;
                  color: #3D3D3D;
                  margin-top: 5px;
                }
              }
              .right {
                margin-left: 20px;
                font-size: 20px;
                color: rgba(0, 0, 0, 0.4);
              }
              &:nth-child(odd) {
                margin-left: 0;
              }
            }
          }
        }
        .apply {
          .name {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.9);
            text-align: left;
            margin: 8px 0;
          }
          .texts {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 24px;
            display: flex;
            .text-t {
              font-family: PingFang SC;
              white-space: nowrap;
            }
            .text-c {
              font-family: PingFang SC;
              text-align: left;
            }
          }
        }
        .details {
          .name {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.9);
            text-align: left;
            margin: 12px 0;
          }
          .texts {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 24px;
            display: flex;
            .text-t {
              font-family: PingFang SC;
              white-space: nowrap;
            }
            .text-c {
              font-family: PingFang SC;
              text-align: left;
            }
            .green {
              font-family: PingFang SC;
              color: #358C05;
            }
          }
        }
        .report {
          .name {
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.9);
            text-align: left;
            margin: 12px 0;
          }
          .texts {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 24px;
            display: flex;
            .text-t {
              font-family: PingFang SC;
              white-space: nowrap;
            }
            .text-c {
              font-family: PingFang SC;
              text-align: left;
            }
            .green {
              font-family: PingFang SC;
              color: #358C05;
            }
          }
        }
      }
      .answer-display {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.9);
        text-align: left;
        margin: 16px 0 6px 0;
      }
      .answer-status {
        .text {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.6);
          text-align: left;
          line-height: 24px;
        }
        .graph {
          display: flex;
          align-items: center;
          margin: 4px 0;
          .chart-container {
            width: calc(100% - 80px);
            .chart {
              height: 12px;
              background: rgba(54, 110, 244, 0.2);
              border-radius: 80px;
            }
          }
          .data {
            width: 80px;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.6);
            text-align: right;
          }
        }
      }
      .answer-status-display {
        .graph {
          .chart-container {
            .chart {
              background: rgba(54, 110, 244, 0.2);
            }
          }
        } 
        .graph-right {
          .chart-container {
            .chart {
              background: #366EF4;
            }
          }
          .data {
            color: #003CAB;
          }
        }

      }
      .answer-status-diagnose {
        .graph {
          .chart-container {
            .chart {
              background: #CBE8EE;
            }
          }
        } 
        .graph-right {
          .chart-container {
            .chart {
              background: #00D6C5;
            }
          }
          .data {
            color: #007979;
          }
        }
      }
    }
  }
  .card-empty-status {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .img-card-empty-status {
      width: 196px;
      height: 154px;
      margin: 0 auto;
      margin-top: 64px;
    }
    .text {
      text-align: center;
      font-size: 16px;
      font-weight: normal;
      font-family: PingFang SC;
      color: #8DA0C2;
    }
  }
}
/deep/.carousel-container .el-carousel__item {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.carousel-container .el-carousel__container {
  max-height: 160px;
}
/deep/.carousel-container .el-carousel__button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/views/teachAnalysis/ClassWrongDetails.vue